var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basePopup',{ref:"basePopup",attrs:{"tips":_vm.tips}},_vm._l((_vm.translateList),function(trans){return _c('div',{key:trans.label,staticClass:"translate-list-item",class:{ active: trans.value === _vm.lang },on:{"click":function($event){return _vm.confirmPopup(trans.value)}}},[_vm._v(_vm._s(trans.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }